module.exports = __webpack_public_path__ + "static/media/b87f211b-7121-40bd-b05a-c665b2ff01f7.bf6cd8e7.jpeg";